import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EndpointsConfig } from 'src/app/config/endpoints.config';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private http: HttpClient, private router: Router, public jwtHelper: JwtHelperService) { }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    // Check whether the token is expired and return
    // true or false
    return !this.jwtHelper.isTokenExpired(token);
  }
  GetToken() {
    return this.http.get<any>(EndpointsConfig.examinee.getToken);
  }
  logout(): void {
    sessionStorage.clear();
    localStorage.removeItem('fLogin');
    localStorage.removeItem('lastTime');
    localStorage.removeItem('token');
    localStorage.removeItem('ExamineauthorizationData');
    localStorage.removeItem('fLogin');
    this.router.navigateByUrl('/');
  }
  ClearData(): void {
    sessionStorage.clear();
    localStorage.clear();
  }
  SetData(data: any): void {
    const rs = JSON.parse(data);
    const saveInfo: any = {};
    saveInfo.UserID = rs.UserID?.trim();
    saveInfo.MailAdress = rs.MailAdress?.trim();
    saveInfo.Name = rs.Name?.trim();
    saveInfo.KanaName = rs.KanaName?.trim();
    saveInfo.DateOfBirth = rs.DateOfBirth?.trim();
    saveInfo.Gender = rs.Gender.trim();
    saveInfo.PhoneNum = rs.PhoneNum?.trim();
    saveInfo.PostalCode = rs.PostalCode?.trim();
    saveInfo.Adress1 = rs.Adress1?.trim();
    saveInfo.Adress2 = rs.Adress2?.trim();
    saveInfo.RegistrationDiv = rs.RegistrationDiv?.trim();
    saveInfo.CountryCode = rs.CountryCode?.trim();
    localStorage.ExamineauthorizationData = JSON.stringify(saveInfo);
    localStorage.fLogin = 'true';
  }
}
